export interface AssignedRolesInfo {
    IsInNewFcaReadOnly: boolean,
    IsInNewFcaSettlementTeam: boolean,
    IsInNewFcaAnalysisTeam: boolean,
    IsInNewFcaManagementTeam: boolean,
    IsInNewFcaAdmin: boolean
  }